import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

import { DASHBOARD_STALE_TIME } from './constants'

export function useAdminDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'adminStats'],
    queryFn: async () =>
      unwrapApiData(
        await client.GET('/v1/admin/dashboard'),
        'Failed to fetch dashboard stats',
      ),
    staleTime: DASHBOARD_STALE_TIME,
  })
}
